import React, {Fragment} from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";
import {DialogActions, IconButton} from "@mui/material";
import Members from "../FormSpreeForms/ContactUs/Members";
import CloseIcon from "@mui/icons-material/Close";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook"; 

export default function AboutUs({open, handleClose}) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const handleDialogClose = () => {
        handleClose();
    };

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleDialogClose}
                fullScreen={fullScreen}
                aria-labelledby="about-us-dialog-title"
            >
                <DialogTitle id="about-us-dialog-title">About Us</DialogTitle>
                <DialogContent>
                    <IconButton
                        style={{position: "absolute", top: 10, right: 10}}
                        onClick={handleDialogClose}
                    >
                        <CloseIcon/>
                    </IconButton>
                    <Typography>
                        At The Halal Foodie, we're all about connecting Albertans and tourists with delicious halal
                        options nearby.
                        It's been quite a challenge gathering all this info in one place, but that's why we're here – to
                        make it easy for you to find your next tasty meal. Join us as we explore Alberta's vibrant halal
                        food scene together, one bite at a time!
                    </Typography>
                    <br/>
                    <Typography>
                        An important disclaimer, <strong>we're not here to play the role of a certification
                        board</strong>. Our aim is
                        simple: we gather information from various sources that confirm a restaurant's halal status. We
                        encourage all our customers to trust their instincts and verify any doubts they may have. And if
                        you stumble upon any information that seems blatantly wrong, please don't hesitate to get in
                        touch with us. We're here to help.
                    </Typography>
                    <br/>
                    <Typography>Download our app:</Typography>
                    <div style={{display: "flex", justifyContent: "center", gap: "10px", marginTop: "10px"}}>
                        <IconButton
                            color="primary"
                            href="https://play.google.com/store/apps/details?id=com.thehalalfoodie.www.twa"
                            target="_blank"
                            style={{backgroundColor: "#34A853"}}
                        >
                            <AndroidIcon style={{color: "white"}}/>
                        </IconButton>
                        <IconButton
                            color="primary"
                            href="https://apps.apple.com/us/app/the-halal-foodie/id6503676681"
                            target="_blank"
                            style={{backgroundColor: "#000000"}}
                        >
                            <AppleIcon style={{color: "white"}}/>
                        </IconButton>
                    </div>
                    <br/>
                    <Typography>Follow us:</Typography>
                    <div style={{display: "flex", justifyContent: "center", gap: "10px", marginTop: "10px"}}>
                        <IconButton
                            color="primary"
                            href="https://www.instagram.com/thehalalfoodieapp/"
                            target="_blank"
                            style={{backgroundColor: "#E4405F"}}
                        >
                            <InstagramIcon style={{color: "white"}}/>
                        </IconButton>
                        <IconButton
                            color="primary"
                            href="https://www.facebook.com/profile.php?id=61568642143188"
                            target="_blank"
                            style={{ backgroundColor: "#1877F2" }}
                        >
                            <FacebookIcon style={{ color: "white" }} />
                        </IconButton>
                        <IconButton
                            color="primary"
                            href="https://www.tiktok.com/@thehalalfoodie"
                            target="_blank"
                            style={{ backgroundColor: "#000000" }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="white"
                                style={{ width: "24px", height: "24px" }}
                            >
                                <path d="M16.5,6.5c-0.02,1.22,0.94,2.37,2.37,2.5c0.08,0,0.16,0.01,0.24,0.01c0.34,0,0.67-0.05,0.98-0.14v2.24 c-0.46,0.08-0.93,0.14-1.42,0.14c-1.62,0-3.06-0.66-4.12-1.73c-1.02-1.02-1.69-2.37-1.79-3.91v8.88c0,2.65-2.14,4.79-4.79,4.79 c-0.33,0-0.65-0.03-0.96-0.09c-0.86-0.17-1.64-0.57-2.26-1.14C4.33,17.84,4,16.95,4,15.98c0-2.65,2.14-4.79,4.79-4.79 c0.31,0,0.61,0.03,0.91,0.09c0.23,0.05,0.46,0.12,0.67,0.21V3.48H13c0.07,0.01,0.15,0.01,0.22,0.01c0.39,0,0.78-0.05,1.15-0.14v2.1 C14.12,6.27,15.3,6.37,16.5,6.5z M8.79,12.37c-1.53,0-2.79,1.25-2.79,2.79c0,0.53,0.15,1.02,0.4,1.44c0.51,0.86,1.45,1.44,2.39,1.44 c1.53,0,2.79-1.25,2.79-2.79V12.79c-0.25-0.11-0.52-0.2-0.8-0.26C9.47,12.41,9.14,12.37,8.79,12.37z" />
                            </svg>
                        </IconButton>
                    </div>
                    <br/>
                    <Typography variant="h6" gutterBottom>
                        Want to Work with Us?
                    </Typography>
                    <br/>
                    <Typography variant="body1">
                        We're looking for passionate volunteers to help us grow. Whether you're in engineering,
                        marketing,
                        or willing to lend a hand in any way, we'd love to hear from you! Join us in building a platform
                        that makes it easier to find halal food options for everyone. Reach out to us and let's create
                        something amazing together!
                    </Typography>
                    <br/>
                    <Members/>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleDialogClose}
                        color="primary"
                        variant="contained"
                        style={{marginTop: "20px"}}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}
